import { DeliveryOptionsEnum, } from '@as-react/common-types';
class CustomerUtil {
    static isUpdateNamesAndTitleForCustomerDetails(delivery) {
        return !this.isLoggedInUser(delivery) || !this.isDeliveredToDeliveryAddress(delivery.chosenDeliveryOption);
    }
    static isDeliveredToDeliveryAddress(deliveryName, info) {
        return ((!info || !!info.requiresDelivery) &&
            [DeliveryOptionsEnum.HOME_DELIVERY, DeliveryOptionsEnum.NAMED_DAY, DeliveryOptionsEnum.NEXT_DAY].includes(deliveryName));
    }
    static isInvoiceEnabled(hideInvoice, delivery) {
        return !!delivery && !hideInvoice && this.isLoggedInUser(delivery);
    }
    static isLoggedInUser(delivery) {
        if (!delivery.customerDetails) {
            return false;
        }
        return delivery.customerDetails.emailOnly === false;
    }
    static getCustomerNames(delivery, optionName) {
        if (optionName &&
            this.isDeliveredToDeliveryAddress(optionName) &&
            delivery.deliveryAddress.firstName &&
            delivery.deliveryAddress.lastName &&
            delivery.deliveryAddress.idTitle &&
            delivery.deliveryAddress.idTitle > 0) {
            return this.createCustomerNames(delivery.deliveryAddress);
        }
        else {
            return this.createCustomerNames(delivery.customerDetails);
        }
    }
    static createCustomerNames(customer) {
        return {
            idTitle: customer.idTitle,
            firstName: customer.firstName,
            middleName: customer.middleName || '',
            lastName: customer.lastName,
        };
    }
    static sortSocialMediaConnections(socialMediaConnections, enabledSocialPlatforms) {
        const platforms = enabledSocialPlatforms.map(platform => {
            const connections = socialMediaConnections.filter(connection => platform === connection.type);
            return {
                title: platform,
                hasConnections: !!connections,
                connections: connections,
                errors: {
                    alreadyConnected: false,
                    connectedToAnother: false,
                },
            };
        });
        return platforms;
    }
    static convertPhoneNumberPrefix(phoneNumber, from, to) {
        if (!phoneNumber) {
            return phoneNumber;
        }
        return (phoneNumber.startsWith(from) ? phoneNumber.replace(from, to) : phoneNumber);
    }
}
export default CustomerUtil;
